import { useAPI } from 'utils/hooks/useAPI'
import { AiIndexesSectionCSS } from './AiIndexesSectionCSS.styled'
import { API } from 'constants/apiEndPoints'
import { useEffect, useState } from 'react'
import { ASYNC_STATUS_ID } from 'constants/index'
import { getAssetInfo } from 'constants/assets'
import { isEmpty } from 'lodash'
import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'
import { AssetRow } from '../AssetRow'
import { DateTime } from 'luxon'
import { Link } from 'components/Atoms/Link'

const COLOR_ARRAY = [
  '#000000',
  '#0151ff',
  '#fdfb03',
  '#002869',
  '#2b7088',
  '#ce39c5',
  '#494af4',
  '#0396b8',
  '#fb9908',
  '#4867aa',
  '#c80200',
  '#07cb00',
  '#cc0201',
  '#003087',
  '#177aba',
  '#cc2427',
  '#ffcb08',
]
const getRamdomColor = () => {
  const randomIndex = Math.floor(Math.random() * COLOR_ARRAY.length)
  return COLOR_ARRAY.at(randomIndex)
}

export const AiIndexesSection = () => {
  //START - Get assets in the index
  const [loading, setLoading] = useState(true)
  const [assetsList, setAssetsList] = useState([[], []])
  const [aiIndexState, getAiIndex, hasAiIndexStatus] = useAPI(API.YOLO_ETF_ASSETS, {
    queryType: 'get',
    controlled: true,
  })

  useEffect(() => {
    getAiIndex({ params: { symbol: 'AutoGPT' } })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (hasAiIndexStatus(ASYNC_STATUS_ID.ERROR)) {
    }
    if (hasAiIndexStatus(ASYNC_STATUS_ID.CONFIRMED)) {
      const data = aiIndexState?.data?.etf_compnents_data
      const assetsInfo = data.map((asset) => {
        const assetInfo = getAssetInfo(asset.component_symbol)
        if (isEmpty(assetInfo)) return { id: asset.component_symbol, color: getRamdomColor() }
        else return assetInfo
      })

      const halfArrayLength = Math.floor(assetsInfo.length / 2)
      const subArray1 = assetsInfo.slice(0, halfArrayLength)
      const subArray2 = assetsInfo.slice(halfArrayLength)
      setAssetsList([subArray1, subArray2])
      setLoading(false)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aiIndexState.status?.id])
  //END - Get assets in the index

  return (
    <AiIndexesSectionCSS>
      <section className='ai_indexes_section_1'>
        <div className='row ai_indexes_statement_1'>
          YOLO AI synthetic stock indexes are created by{' '}
          <Link href='https://twitter.com/chatgpttrader' target='blank'>
            GPT Portfolio
          </Link>
          , then curated and customized by AutoGPT using comprehensive technical analysis, current news sentiment, and
          market data.
        </div>
        <div className='row ai_indexes_selections'>
          <div className='grid-content'>
            <SingleDataLoader
              loading={loading}
              data={assetsList.at(0).map((assetInfo, idx) => {
                return <AssetRow key={`asset1${idx}`} assetInfo={assetInfo} />
              })}
            />
          </div>

          <div className='grid-content'>
            <SingleDataLoader
              loading={loading}
              data={assetsList.at(1).map((assetInfo, idx) => (
                <AssetRow key={`asset2${idx}`} assetInfo={assetInfo} />
              ))}
            />
          </div>
        </div>
        <div className='row ai_indexes_statement_2'>
          Orders will auto-close every Friday at 4pm EST and a new list of 20 synthetic stocks will be selected by YOLO
          AI.
        </div>
      </section>
    </AiIndexesSectionCSS>
  )
}
